import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import * as enums from '../../../../utils/EnumMapping';
import MainTable from '../../../common/table/MainTable';
import * as columns from './CarColumns';
import NewCar from './NewCar';

class Car extends Component {

    enrich = (data) => {
        data.map((item) => {
            item.rowType = "CAR";
            item.state = enums.getSecondValue(enums.activeStates, item.active);
            item.stateLabel = enums.getLabel(enums.activeStates, item.active);
            return item;
        })
        console.log(data);
        return data;
    }

    render() {
        return (
            <MainTable
                divClassName="car"
                tableName="Autók"
                newObjectLabel="Új autó hozzáadása"
                path='/api/cars'
                enrich={this.enrich}
                columns={(refresh) => columns.columns(refresh)}
                dialogContent={(refresh, close) => <NewCar refresh={refresh} close={close} />} />
        );
    }
}

export default withSnackbar(Car);